import { useEffect, useCallback } from "react";
import styles from "./index.module.less";
import { useNavigate } from "react-router-dom";
import { useState } from "react";
import { useUser } from "@/utils/UserContext";
import xjc from "@/assets/img/xjc.png";
import {
  getCaseList,
  getDictIdByCode,
  getAllDict,
  getDictListById,
  editActivity,
  deleteActivity,
} from "@/services/history";

import {
  SelectField,
  ButtonField,
  Iconsvg,
  Pagination,
} from "@wk/components-react16";
import { findValueByIdAndKey, isSubmissionClosed } from "@/utils";
import ModalConfirm from "../modal";
import { cloneDeep } from "lodash-es";

const PersonalCases = () => {
  const navigate = useNavigate();
  const { user } = useUser();
  const [userInfo, setUserInfo] = useState();
  const [yearDict, setYearDict] = useState([]);
  const [yearValue, setYearValue] = useState("");
  const [historyList, setHistoryList] = useState([]);
  const [total, setTotal] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);
  const [alList, setAlList] = useState([]);
  const [isDeleteModalOpen, setIsDeleteModalOpen] = useState(false);
  const [isWithdrawModalOpen, setIsWithdrawModalOpen] = useState(false);

  const [deleteId, setDeleteId] = useState("");
  const [retractId, setRetractId] = useState();

  const [isModalConfirmLoading, setIsModalConfirmLoading] = useState(false);
  const [isSubError, setIsSubError] = useState(false);
  const [isDelError, setIsDelError] = useState(false);

  // 投稿截止提示弹窗
  const [isClosedOpen, setIsClosedOpen] = useState(false);
  const [messageText, setMessageText] = useState("");

  const getYearDict = async () => {
    const res = await getAllDict("belong_year");
    if (res.code === 200) {
      setYearDict(
        res.result
          // .filter((item) => item.value !== "2018" && item.value !== "2019")
          .map((item) => ({
            name: item.value + "年",
            value: item.value,
          }))
      );
    }
  };

  const getCaseTypeDict = async (code) => {
    try {
      const resList = await getDictIdByCode({ code });
      const id = resList?.result?.records[0]?.id || "";
      const itemList = await getDictListById({ dictId: id, pageSize: -1 });
      return itemList?.result?.records || [];
    } catch (error) {
      return [];
    }
  };

  const getAlList = async () => {
    const zcList = await getCaseTypeDict("al");
    setAlList(zcList);
  };

  const alText = useCallback(
    (detail) => {
      if (!detail) return "-";
      return (
        findValueByIdAndKey(alList, detail?.caseType, "itemText", "id") ||
        detail?.anliType ||
        "-"
      );
    },
    [alList]
  );

  const getCaseLists = async (params) => {
    const res = await getCaseList(params);
    if (res.code === 200) {
      setHistoryList(res.result.records);
      setTotal(res.result.total);
    }
  };

  // 点击下一页
  const onNextArrowClick = () => {
    setCurrentPage((prev) => prev + 1);
    scrollToHistoryList();
  };

  // 点击上一页
  const onPreviousClick = () => {
    setCurrentPage((prev) => prev - 1);
    scrollToHistoryList();
  };

  // 点击页码
  const onPageClick = (event) => {
    setCurrentPage(event);
    scrollToHistoryList();
  };

  const scrollToHistoryList = () => {
    const historyListElement = document.querySelector(".history-list");
    if (historyListElement) {
      historyListElement.scrollIntoView({ behavior: "smooth" });
    }
  };

  const goDetail = (id) => {
    console.log(id);
    // 跳转路由到详情页面
    navigate(`/history/detail?id=${id}`);
  };

  const getList = useCallback(() => {
    if (!userInfo?.phone) return;

    const params = {
      pageNo: currentPage,
      pageSize: 10,
      phoneNumber: userInfo?.phone,
      // phoneNumber: 18600310463,
      belongYear: yearValue,
      px: "2",
    };
    getCaseLists(params);
  }, [userInfo, yearValue, currentPage]);

  const edit = async (item, number) => {
    const value = cloneDeep(item);
    // 投稿截止后不允许提交案例（仅拦截正式提交 commitStatus="2"）
    if (number === "2" && isSubmissionClosed()) {
      setMessageText("投稿已截止，无法提交案例");
      setIsClosedOpen(true);
      return;
    }
    if (
      !value?.name ||
      !value?.caseType ||
      !value?.institution ||
      !value?.dept ||
      !value?.description ||
      !value?.fileUrl ||
      !value?.imgUrl
    ) {
      setIsSubError(true);
      return;
    }

    value.commitStatus = number;
    const findItem = historyList.find((item) => item.id === value.id);
    if (findItem) {
      findItem.isEditingLoading = true;
      setHistoryList([...historyList]);
    }

    const res = await editActivity({
      ...value,
      firstUserKey: value?.firstUserId,
      secondUserKey: value?.secondUserId,
    });

    if (findItem) {
      findItem.isEditingLoading = false;
      setHistoryList([...historyList]);
    }

    // 更新列表
    if (res.code === 200) {
      getList();
    } else {
      // 后端拦截（如投稿已截止）时提示错误信息
      setMessageText(res?.message || "提交失败，请稍后重试");
      setIsClosedOpen(true);
    }
  };

  const deleteCases = useCallback(async () => {
    setIsModalConfirmLoading(true);
    const res = await deleteActivity(deleteId);

    setIsModalConfirmLoading(false);
    if (res.code === 200) {
      setIsDeleteModalOpen(false);
      setDeleteId("");
      getList();
    }
  }, [deleteId]);

  const withdrawCases = useCallback(async () => {
    setIsModalConfirmLoading(true);
    if (!retractId) {
      return;
    }
    const res = await editActivity({
      ...retractId,
      commitStatus: "1",
      firstUserKey: retractId?.firstUserId,
      secondUserKey: retractId?.secondUserId,
    });

    setIsModalConfirmLoading(false);
    if (res.code === 200) {
      setIsWithdrawModalOpen(false);
      setRetractId();
      getList();
    }
  }, [retractId]);

  useEffect(() => {
    setUserInfo(user);
  }, [user]);

  useEffect(() => {
    getList();
  }, [userInfo, yearValue, currentPage]);

  useEffect(() => {
    getYearDict();
    getAlList();
  }, []);

  return (
    <div className={styles["personal-cases"]}>
      <div className="personal-section">
        <img src={xjc} alt="" />
        <div className="personal-section-title">
          第九届UpToDate临床顾问案例大赛
        </div>
        <div className="personal-section-subtitle">创建你的新案例吧</div>

        <ButtonField iconPosition={"right"}>
          <button
            type="button"
            onClick={() => {
              // 投稿截止后不允许创建新案例，点击弹窗提示
              if (isSubmissionClosed()) {
                setMessageText("投稿已截止，无法提交案例");
                setIsClosedOpen(true);
                return;
              }
              navigate("/player/personalCases/add");
            }}
          >
            创建新案例
            <Iconsvg name="arrow-right"></Iconsvg>
          </button>
        </ButtonField>
      </div>

      <div className="personal-list">
        <div className="year-select">
          <SelectField labelFor="select-id-1-1">
            <select
              id="select-id-1-1"
              name="story1-1"
              value={yearValue || ""}
              onChange={(e) => {
                setYearValue(e.target.value);
                setCurrentPage(1);
              }}
            >
              <option disabled hidden>
                请选择一个年份
              </option>

              <option value="">全部</option>
              {yearDict.map((item) => {
                return (
                  <option value={item.value} key={item.value}>
                    {item.name}
                  </option>
                );
              })}
            </select>
          </SelectField>
        </div>

        <div className="history-list">
          {historyList.map((item, index) => {
            return (
              <div className="history-list-item" key={item.id}>
                <img
                  src={item?.imgUrl ? item.imgUrl.split(",")[0] : ""}
                  alt=""
                  className="history-list-item-img"
                />
                <div className="left-box">
                  <div className="history-list-item-info">
                    <div className="item-title">{item.name}</div>
                    <div className="item-desc">{item.description}</div>
                    <div className="item-date">
                      <div className="item-number">案例编号: {item.number}</div>
                      <div className="item-status">
                        案例状态:
                        <span
                          className={
                            item.commitStatus == "2"
                              ? "status-submitted"
                              : item.commitStatus == "1"
                              ? "status-unsubmitted"
                              : ""
                          }
                        >
                          {item.commitStatus == "2"
                            ? "已提交"
                            : item.commitStatus == "1"
                            ? "未提交"
                            : "-"}
                        </span>
                      </div>
                      <div className="item-type">案例类型: {alText(item)}</div>
                    </div>
                  </div>

                  {item.commitStatus == "1" && (
                    <div className="history-list-item-btn">
                      <ButtonField mode={"ghost"}>
                        <button
                          type="button"
                          onClick={() => {
                            navigate(
                              `/player/personalCases/edit?id=${item.id}`
                            );
                          }}
                          disabled={item.firstPhone != userInfo?.phone}
                        >
                          编辑案例
                        </button>
                      </ButtonField>

                      <ButtonField iconPosition={"right"} mode={"ghost"}>
                        <button
                          type="button"
                          onClick={() => edit(item, "2")}
                          disabled={
                            item?.isEditingLoading ||
                            item.firstPhone != userInfo?.phone ||
                            isSubmissionClosed()
                          }
                        >
                          {isSubmissionClosed() ? "投稿已截止" : "提交"}
                          {item?.isEditingLoading ? (
                            <Iconsvg name="spinner-alt" isSpin></Iconsvg>
                          ) : (
                            <Iconsvg name="arrow-right"></Iconsvg>
                          )}
                        </button>
                      </ButtonField>
                    </div>
                  )}

                  {item.commitStatus == "2" && (
                    <div className="history-list-item-btn">
                      <ButtonField mode={"ghost"}>
                        <button
                          type="button"
                          onClick={() => {
                            setRetractId(item);
                            setIsWithdrawModalOpen(true);
                          }}
                          disabled={
                            item.firstPhone != userInfo?.phone ||
                            (item.tbScoreFinalArr.length > 0 &&
                              item.tbScoreFinalArr.find((itemTb) => {
                                return itemTb?.score || itemTb?.score === 0;
                              }))
                          }
                        >
                          撤回案例
                        </button>
                      </ButtonField>

                      <ButtonField iconPosition={"right"} mode={"ghost"}>
                        <button type="button" onClick={() => goDetail(item.id)}>
                          查看
                          <Iconsvg name="arrow-right"></Iconsvg>
                        </button>
                      </ButtonField>
                    </div>
                  )}

                  <div
                    className="del"
                    onClick={() => {
                      if (item.firstPhone != userInfo?.phone) {
                        setIsDelError(true);
                        return;
                      }

                      setDeleteId(item.id);
                      setIsDeleteModalOpen(true);
                    }}
                  >
                    <Iconsvg name="trash" size={16} color="#353535"></Iconsvg>
                  </div>
                </div>
              </div>
            );
          })}

          {historyList.length === 0 && (
            <div className="no-data">无搜索结果</div>
          )}

          <div className="pagination-box">
            {total > 0 && (
              <Pagination
                pageIndex={currentPage}
                controlMode={"controlled"}
                pageCount={Math.ceil(total / 10)}
                onOnNextArrowClick={onNextArrowClick}
                onOnPreviousArrowClick={onPreviousClick}
                onOnPageClick={(event) => onPageClick(event)}
              />
            )}
          </div>
        </div>
      </div>

      <ModalConfirm
        isOpen={isDeleteModalOpen}
        onClose={() => {
          setIsDeleteModalOpen(false);
          setDeleteId("");
          setIsModalConfirmLoading(false);
        }}
        children={<div className="modal-body-text">是否删除案例?</div>}
        title={"操作确认"}
        onConfirm={() => deleteCases()}
        isConfirmLoading={isModalConfirmLoading}
        okText="确认删除"
      />

      <ModalConfirm
        isOpen={isWithdrawModalOpen}
        onClose={() => {
          setIsWithdrawModalOpen(false);
          setRetractId();
          setIsModalConfirmLoading(false);
        }}
        children={<div className="modal-body-text">是否撤回上传的案例?</div>}
        title={"操作确认"}
        onConfirm={() => withdrawCases()}
        isConfirmLoading={isModalConfirmLoading}
        okText="确认撤回"
      />

      <ModalConfirm
        isOpen={isSubError}
        onClose={() => {
          setIsSubError(false);
        }}
        children={
          <div className="modal-body-text">请将案例信息填写完整后提交</div>
        }
        title={"操作确认"}
        onConfirm={() => setIsSubError(false)}
        okText="确认"
      />

      <ModalConfirm
        isOpen={isClosedOpen}
        onClose={() => {
          setIsClosedOpen(false);
          setMessageText("");
        }}
        children={<div className="modal-body-text">{messageText}</div>}
        title={"操作确认"}
        onConfirm={() => {
          setIsClosedOpen(false);
          setMessageText("");
        }}
        okText="确认"
      />

      <ModalConfirm
        isOpen={isDelError}
        onClose={() => {
          setIsDelError(false);
        }}
        children={<div className="modal-body-text">二作无法删除案例</div>}
        title={"操作确认"}
        onConfirm={() => setIsDelError(false)}
        okText="确认"
      />
    </div>
  );
};
export default PersonalCases;
